import React, { useState } from 'react';
import Modal from '@tencent/dui/lib/components/Modal';
import i18n from '@i18next/i18n';
import { NumberInput } from '@tencent/wb-ext-form';
import { ColumnDataCm, ColumnSpaceCm } from '../interface';
import style from './style.less';
import { COLUMN_NUMBER_STEP, COLUMN_SPACE_STEP, DEFAULT_COLUMN_NUMBER, DEFAULT_COLUMN_SPACE, MAX_COLUMN_NUMBER, MAX_COLUMN_NUMBER_LENGTH, MAX_COLUMN_SPACE, MAX_COLUMN_SPACE_LENGTH, MIN_COLUMN_NUMBER, MIN_COLUMN_SPACE } from '../constant';

interface Props {
    defaultColumnNumber?: number;
    defaultColumnSpace?: ColumnSpaceCm;
    onClose: () => void;
    onOk: (columnData: ColumnDataCm) => void;
}

export type IColumnDialog = React.FC<Props>;

const ColumnDialog = (props: Props) => {
    const { defaultColumnNumber, defaultColumnSpace, onClose, onOk } = props;
    const [columnNumber, setColumnNumber] = useState(defaultColumnNumber);
    const [columnSpace, setColumnSpace] = useState(defaultColumnSpace);
    const handleOk = (event) => {
        // 根据 dui 文档，没有 event 参数表示是 enter 按键触发。
        // 按键触发保存时由于不会触发 input 的 blur，也就无法触发 input 值的合法化校验，导致非法参数被保存，所以在这里禁用 enter 保存
        if (!event) {
            return;
        }
        onOk({
            columnNumber,
            columnSpace,
        });
    };
    const handleColumnNumberChange = (value: string) => {
        setColumnNumber(Number(value));
    };
    const handleColumnSpaceChange = (value: string) => {
        const spaceNumber = parseFloat(value);
        setColumnSpace(parseFloat(spaceNumber.toFixed(2)) as ColumnSpaceCm);
    };
    return (
        <Modal
            title={i18n.t('分栏')}
            visible={true}
            style={{ width: '260px' }}
            onClose={onClose}
            onCancel={onClose}
            onOk={handleOk}
        >
            <div className={style['column-dialog-body']}>
                <div className={style['column-dialog-item']}>
                    <label>{i18n.t('栏数')}:</label>
                    <NumberInput
                        min={MIN_COLUMN_NUMBER}
                        max={MAX_COLUMN_NUMBER}
                        maxLength={MAX_COLUMN_NUMBER_LENGTH}
                        value={`${columnNumber || DEFAULT_COLUMN_NUMBER}`}
                        step={COLUMN_NUMBER_STEP}
                        style={{ width: '90px' }}
                        onChange={handleColumnNumberChange}
                    />
                </div>
                <div className={style['column-dialog-item']}>
                    <label>{i18n.t('栏间距')}:</label>
                    <NumberInput
                        min={MIN_COLUMN_SPACE}
                        max={MAX_COLUMN_SPACE}
                        maxLength={MAX_COLUMN_SPACE_LENGTH}
                        value={`${columnSpace || DEFAULT_COLUMN_SPACE}`}
                        step={COLUMN_SPACE_STEP}
                        style={{ width: '90px' }}
                        allowDecimal={true}
                        toFixed={2}
                        suffix={i18n.t('厘米')}
                        onChange={handleColumnSpaceChange}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default ColumnDialog;
